import styled from 'styled-components';
import { VisuallyHidden } from '../../../../../utils.styles';

export const RemoveItemsButtonIcon = styled.span`
    margin-right: 8px;
`;

export const RemoveItemsButtonText = styled.span`
    &:hover {
        text-decoration: underline;
    }
`;

export const A11yText = styled.span`
    ${VisuallyHidden};
`;
